import $ from 'jquery';
import 'slick-slider/slick/slick';
import Typed from 'typed.js';
import '@fancyapps/fancybox';
// import 'jplayer/dist/jplayer/jquery.jplayer';

$(() => {
	const url = getLocation(location.href);
	const newString = url.hash;
	const testString = newString.substr(1);
	console.log(url, testString);
	let tab;
	if (testString) {
		if ((testString === '01PR') || (testString === '01PRLux') || (testString === '01PRTerma') || (testString === '01PRPrime' || (testString === '01PRKM0') || (testString === '01PRKM1') || (testString === '01PRDUO') || (testString === '01DLeto') || (testString === '01DZima') || (testString === '01PREconom') || (testString === '01PREconomPlus')) ) {
			console.log('дерево');
			tab = 'wood';
			$('.js-catalog-category[data-class="' + tab + '"]').next().slideToggle(1000);
		}else if ((testString === '01BLeto') || (testString === '01BZima') || (testString === 'SV94')) {
			console.log('Бетон');
			tab = 'beton';
			$('.js-catalog-category[data-class="' + tab + '"]').next().slideToggle(1000);
		}else if (testString === '01K') {
			console.log('Кабель');
			tab = 'cabel';
			$('.js-catalog-category[data-class="' + tab + '"]').next().slideToggle(1000);
		}else if (testString === '01V') {
			console.log('Воздух');
			tab = 'vent';
			$('.js-catalog-category[data-class="' + tab + '"]').next().slideToggle(1000);
		}else if ((testString === 'F-712') || (testString === '01mppu') || (testString === 'CB25Walls') || (testString === 'CB25Floor') || (testString === 'CB25Walls') || (testString === 'CB25Metall') || (testString === 'CB25Art') || (testString === 'CB25Finish') || (testString === 'CB25Lifts') || (testString === 'CB7Antic') || (testString === 'CB7Mini') || (testString === 'CB7Fur') || (testString === 'CB7Cor') || (testString === 'F-7min') || (testString === 'F-7Fur') || (testString === 'F-7Cor')) {
			console.log('Краски и составы негорючие для путей эвакуации');
			tab = 'ways';
			$('.js-catalog-category[data-class="' + tab + '"]').next().slideToggle(1000);
		}else if ((testString === 'clothWool') || (testString === 'clothPort') || (testString === 'clothBed') || (testString === 'clothFloor') || (testString === 'clothSynt')) {
			console.log('Пропитки по тканям, коврам, одежде');
			tab = 'cloth';
			$('.js-catalog-category[data-class="' + tab + '"]').next().slideToggle(1000);
		}else if ((testString === 'GF-021') || (testString === 'AK-027') || (testString === 'F115Gold') || (testString === 'F148Gold') || (testString === 'PF115Classic')) {
			console.log('CorrozoStop');
			tab = 'anticor';
			$('.js-catalog-category[data-class="' + tab + '"]').next().slideToggle(1000);
		}else if ((testString === 'F-210') || (testString === 'F-900') || (testString === 'F-425') || (testString === 'F-400')) {
			console.log('Огнеупорные и теплоизоляционные краски и составы');
			tab = 'paints';
			$('.js-catalog-category[data-class="' + tab + '"]').next().slideToggle(1000);
		}else if ((testString === 'F35-9') || (testString === 'F35-2') || (testString === 'F35-3')) {
			tab = 'vodostop';
			console.log('VodoStop');
			$('.js-catalog-category[data-class="' + tab + '"]').next().slideToggle(1000);
			console.log($('.js-catalog-category[data-class="' + tab + '"]'));
		}else if ((testString === 'F2030') || (testString === 'F1240') || (testString === 'F2040') || (testString === 'F96')) {
			console.log('Пол СделаемЛегко');
			tab = 'sdelaemLegko';
			$('.js-catalog-category[data-class="' + tab + '"]').next().slideToggle(1000);
		}else if ((testString === 'BOSMetall') || (testString === 'BOSBeton') || (testString === 'BOSVENT')) {
			console.log('ПРО-все');
			tab = 'bos';
			$('.js-catalog-category[data-class="' + tab + '"]').next().slideToggle(1000);
		}
		// const $tabs = $('.js-catalog-category');
		// $tabs.each(function (index, elem) {
		// 	$(elem).click();
		// 	console.log(index);
		// });
	}
	if (newString) {
		if (newString === '#quiz') {
			$('[data-step="1"]').css({display: 'block'});
			$('body').css({overflowY: 'hidden'});	
		}else {
			const sc = $(`${newString}`);
			let dn = $(sc).offset().top - 120;

			$('html, body').animate({scrollTop: dn}, 1000);
			// console.log(sc);
		}
	}
	function getLocation(href) {
		const match = href.match(/^(https?\:)\/\/(([^:\/?#]*)(?:\:([0-9]+))?)([\/]{0,1}[^?#]*)(\?[^#]*|)(#.*|)$/);
		return match && {
			protocol: match[1],
			host: match[2],
			hostname: match[3],
			port: match[4],
			pathname: match[5],
			search: match[6],
			hash: match[7]
		};
	}
	// });

	$(window).on('scroll', function () {
		if ($(this).scrollTop() > 100) {
			if ($('.js-to-top').is(':hidden')) {
				$('.js-to-top').css({opacity: 1}).fadeIn('slow');
			}
		}else {
			$('.js-to-top').stop(true, false).fadeOut('fast');
		}
	});
	const options = {
		strings: ['Ищу огнезащитную краску для наружных работ', 'Каким составом лучше обработать шторы и обивку мебели в моем ресторане?', 'Помогите подобрать огнезащиту металлоконструкций'],
		typeSpeed: 20,
		backSpeed: 20,
		attr: 'placeholder',
		bindInputFocusEvents: true,
		loop: true
	};
	// eslint-disable-next-line
	const typed = new Typed('.magazine__textarea', options);
	$('.js-to-top').on('click', function () {
		$('html, body').stop().animate({scrollTop: 0}, 300);
	});
	const audio = document.getElementById('audio');
	// audio.prop('autoplay');
	// console.log(audio.prop('autoplay'));
	// $('.first-screen__title').trigger('click');
	$('.js-volume').on('click', function () {
		$('.js-volume').toggleClass('sound-on');
		if ($('.js-volume').hasClass('sound-on')) {
			audio.volume = 0.1;
			audio.play();
		}else {
			audio.pause();
		}
	});
	/* header */
	const $selectRegion = $('.js-select-region');
	const width = $selectRegion.find('.js-select').width();
	$selectRegion.css('width', width + 25 + 'px');
	$('.js-change').on('click', function () {
		$(this).parentsUntil('.header__wrap').find('.js-select-region .js-select').click();
	});

	$('.js-select').on('click', function () {
		const $dropdown = $(this).parent('.js-dropdown');
		$dropdown.find('.js-menu').slideToggle(300);
		$dropdown.find('.js-select').toggleClass('select__btn_active');
	});
	$(document).on('click', function (e) {
		if (!(e.target.closest('.js-dropdown') || e.target.closest('.js-change'))) {
			const $dropdown = $('.js-dropdown');
			$dropdown.find('.js-menu').slideUp(300);
			$dropdown.find('.js-select').removeClass('select__btn_active');
		}
	});
	$('.js-button').on('click', function () {
		const $dropdown = $(this).closest('.js-dropdown');
		$dropdown.find('.js-flag').attr('value', $(this).attr('id'));
		$dropdown.find('.js-select').attr('src', $(this).find('img').attr('src'));
		$dropdown.find('.js-menu').slideUp(300);
		$dropdown.find('.js-select').removeClass('select__btn_active');
	});
	const $trigger = $('.js-trigger');
	$trigger.mouseenter(function () {
		$(this).find('.trigger__text-wrap').addClass('visible');
	});
	$trigger.mouseleave(function () {
		$(this).find('.trigger__text-wrap').removeClass('visible');
	});
	function showInsertTip() {
		const modTip = $('.js-mod-tip');
		modTip.each(function (index, elem) {
			$(elem).find($('.tip__item')).first().after('<div class="tip__item-insert">Svatozar BOS базальтовые огнезащитные системы:</div>');
		});
	}
	showInsertTip();
	/** scroll */
	$('a[href^="#"]').on('click', function (e) {
		e.preventDefault();
		const sc = $(this).attr('href');
		let dn = $(sc).offset().top;
		if (sc === '#catalog') {
			dn -= 100;
		}
		if (sc === '#complex') {
			dn -= 150;
		}
		if (sc === '#dillers-map') {
			dn -= 150;
		}
		if (sc === '#contacts') {
			dn -= 50;
		}
		if (sc === '#solutions') {
			dn -= 100;
		}
		if (sc === '#colors') {
			dn += 100;
		}

		$('html, body').animate({scrollTop: dn}, 1000);

		if (menuButton) {
			menuButton.click();
		}
	});
	/* burger */
	const menuButton = document.querySelector('.burger');
	menuButton.addEventListener('click', function () {
		const lines = menuButton.children;
		for (const item of lines) {
			item.classList.toggle('burger__line_active');
		}
		const menu = document.querySelector('.header__mobile-menu');
		menu.classList.toggle('header__mobile-menu_active');
	});
	$(document).on('click', function (e) {
		console.log(e.target.closest('js-navlink'));
		if ($('.header__mobile-menu_active') && !(e.target.closest('.burger')) && !(e.target.closest('.header__mobile-menu'))) {
			const lines = menuButton.children;
			for (const item of lines) {
				item.classList.remove('burger__line_active');
			}
			const menu = document.querySelector('.header__mobile-menu');
			menu.classList.remove('header__mobile-menu_active');
		}
	});
	/* tabs */
	$('.js-tab').on('click', function () {
		const curTab = $(this).attr('data-content');
		$('.js-tab').removeClass('active-tab');
		$(this).addClass('active-tab');
		$('.js-tab-content').removeClass('active-content');
		$('.js-tab-content[data-content = "' + curTab + '"]').addClass('active-content');
	});
	/** Tabs end*/

	/** Click on tip */

	const $tip = $('.js-tip-circle');
	$tip.on('click', function () {
		$('.tip__content').removeClass('active-tip');
		// console.log($(this));
		$(this).next('.tip__content').addClass('active-tip');
	});
	$(document).on('click', function (e) {
		if (!((e.target.closest('.tip__content')) || (e.target.closest('.js-tip-circle')))) {
			$('.tip__content').removeClass('active-tip');
		}
	});
	/** solution to catalog */
	const $links = $('.js-product-link');
	$links.on('click', function (e) {
		e.preventDefault();
		const curLinkData = $(this).attr('data-class');
		$('.js-catalog-category[data-class = "' + curLinkData + '"]').next().slideDown();
		const sc = $(this).attr('href');
		const dn = $(sc).offset().top - 120;
		$('html, body').animate({scrollTop: dn}, 1000);

	});

	/** Video */
	const play = document.querySelector('#play');
	const playIsland = document.querySelector('#play1');
	const contain = document.querySelectorAll('.video-box');
	const videoPlayer = document.querySelectorAll('.video');
	const video = document.querySelectorAll('.video__frame');
	play.addEventListener('click', () => {
		contain[0].classList.add('video-box_hidden');
		videoPlayer[0].classList.add('video_visible');
		video[0].contentWindow.postMessage(JSON.stringify({event: 'command', func: 'playVideo'}), '*');
	});
	playIsland.addEventListener('click', () => {
		contain[1].classList.add('video-box_hidden');
		videoPlayer[1].classList.add('video_visible');
		video[1].contentWindow.postMessage(JSON.stringify({event: 'command', func: 'playVideo'}), '*');
	});

	/** Catalog accordeon */
	const $header = $('.js-catalog-category');

	$header.on('click', function () {
		// $('.js-catalog-content').not($(this).next()).slideUp(1000);
		$(this).next().slideToggle(1000);
	});

	$(document).on('click', '.js-quiz-start', () => {
		$('[data-step="1"]').css({display: 'block'});
		$('body').css({overflowY: 'hidden'});
	});

	$(document).on('click', '.js-quiz-close', () => {
		$('.js-quiz').css({display: 'none'});
		$('body').css({overflowY: 'auto'});
	});

	$(document).on('click', '.js-quiz-next', function () {
		const nextStep = $(this).attr('data-next');
		$('.js-quiz').css({display: 'none'});
		$('[data-step="' + nextStep + '"]').css({display: 'block'});
	});

	$(document).on('click', '.js-quiz-back', function () {
		const backStep = $(this).attr('data-back');
		$('.js-quiz').css({display: 'none'});
		$('[data-step="' + backStep + '"]').css({display: 'block'});
	});

	$(document).on('click', '.js-popup-close', () => {
		$('.js-popup').css({display: 'none'});
		$('body').css({overflowY: 'auto'});
	});

	$(document).on('click', '.js-popup-open', function () {
		const popupId = $(this).attr('data-popup');
		$('.js-popup').css({display: 'none'});
		$('.js-popup#' + popupId).css({display: 'block'});
		$('body').css({overflowY: 'hidden'});
	});

	$(document).on('input', '.js-popup-phone', function () {
		const value = $(this).val();
		$(this).closest('.js-popup').find('.js-popup-submit').prop('disabled', !value);
	});

	$(document).on('click', '.js-popup-submit', function () {
		const $parent = $(this).closest('.js-popup');
		const $inputs = $parent.find('input, textarea');
		const data = {type: 'callback', title: $parent.find('.js-popup-title').text()};
		$inputs.each((idx, elem) => {
			const name = $(elem).attr('name');
			const val = $(elem).val();
			data[name] = val;
		});
		$.ajax({
			type: 'post',
			url: 'include/send.php',
			data
		});
		$('.js-popup').css({display: 'none'});
		$('.js-thanks-popup').css({display: 'flex'});
	});

	$('.js-open-form').on('submit', function (e){
		e.preventDefault();
		const msg = $(this).serialize();
		console.log($(this), msg);
		$.ajax({
			type: 'POST',
			url: './include/send.php',
			data: msg,
			success: () => {
				$('.js-thanks-popup').css({display: 'flex'});
			},
			error: xhr => {
				// eslint-disable-next-line
				alert('Возникла ошибка: ' + xhr.responseCode);
			}
		});
	});
	$(document).on('click', '.js-thanks-close', () => {
		$('.js-thanks-popup').css({display: 'none'});
		$('body').css({overflowY: 'auto'});
	});

	$(document).on('input', '.js-quiz-other-input', function () {
		$(this).closest('.js-quiz').find('.js-quiz-other input').prop('checked', true);
	});

	$(document).on('change', '.js-quiz-hide-controll', function () {
		const isChecked = $(this).find('input').prop('checked');
		$(this).next().css({display: isChecked ? 'block' : 'none'});
	});

	$('.js-quiz[data-step="4"] .js-quiz-button, .js-quiz[data-step="6"] .js-quiz-button').prop('disabled', true);

	$(document).on('input', '.js-quiz[data-step="4"] input', function () {
		const $quiz = $(this).closest('.js-quiz');
		const text = $quiz.find('input[name="square"]').val();
		const isChecked = $quiz.find('input[name="cant-square"]').prop('checked');
		$quiz.find('.js-quiz-button').prop('disabled', !text && !isChecked);
	});

	$(document).on('input', '.js-quiz[data-step="6"] input', function () {
		const $quiz = $(this).closest('.js-quiz');
		const text = $quiz.find('input[name="dates"]').val();
		const isChecked = $quiz.find('input[name="cant-dates"]').prop('checked');
		$quiz.find('.js-quiz-button').prop('disabled', !text && !isChecked);
	});

	$(document).on('click', '.js-popup-quiz-close', function () {
		$('.js-popup-quiz').css({display: 'none'});
		$('body').css({overflowY: 'auto'});
	});

	$(document).on('click', '.js-quiz-finish', function () {
		$('.js-quiz').css({display: 'none'});
		$('.js-popup-quiz').css({display: 'block'});
	});

	$(document).on('input', '.js-popup-quiz input', function () {
		$(this).closest('.js-popup-quiz').find('.js-popup-quiz-btn').prop('disabled', !$(this).val());
	});

	$(document).on('click', '.js-popup-quiz-btn', function () {
		const phone = $('.js-popup-quiz input[name="phone"]').val();
		const mail = $('.js-popup-quiz input[name="mail"]').val();

		const what = $('.js-quiz[data-step="1"] input[name="what"]').val();
		const whatOther = $('.js-quiz[data-step="1"] input[name="what-description"]').val();

		const element = $('.js-quiz[data-step="2"] input[name="element"]').val();
		const elementOther = $('.js-quiz[data-step="2"] input[name="element-description"]').val();

		const material = $('.js-quiz[data-step="3"] input[name="material"]').val();
		const materialOther = $('.js-quiz[data-step="3"] input[name="material-description"]').val();

		const square = $('.js-quiz[data-step="4"] input[name="square"]').val();
		const cantSquare = $('.js-quiz[data-step="4"] input[name="cant-square"]').is(':checked');

		const color = $('.js-quiz[data-step="5"] input[name="color"]').val();
		const colorOther = $('.js-quiz[data-step="5"] input[name="color-description"]').val();

		const region = $('.js-quiz[data-step="6"] select[name="region"]').val();
		const canOtherRegion = $('.js-quiz[data-step="6"] input[name="can-other-region"]').is(':checked');
		const regionOther = $('.js-quiz[data-step="6"] input[name="other-region"]').val();

		const dates = $('.js-quiz[data-step="6"] input[name="dates"]').val();
		const cantDates = $('.js-quiz[data-step="6"] input[name="cant-dates"]').is(':checked');

		const client = $('.js-quiz[data-step="6"] input[name="client"]').val();

		const service = $('.js-quiz[data-step="6"] input[name="service"]').val();
		const serviceOther = $('.js-quiz[data-step="6"] input[name="service-description"]').val();

		const data = {
			type: 'quiz',
			what: what === 'Другое' ? `Другое / ${whatOther}` : what,
			element: element === 'Другое' ? `Другое / ${elementOther}` : element,
			material: material === 'Другое' ? `Другое / ${materialOther}` : material,
			square: cantSquare ? 'Затрудняюсь с ответом' : square,
			color: color === 'Другое' ? `Другое / ${colorOther}` : color,
			region: canOtherRegion ? regionOther : region,
			dates: cantDates ? 'Затрудняюсь с ответом' : dates,
			client,
			phone,
			mail,
			service: service === 'Другое' ? `Другое / ${serviceOther}` : service
		};
		$.ajax({
			type: 'post',
			url: 'include/send.php',
			data
		});
		$('.js-popup-quiz').css({display: 'none'});
		$('.js-thanks-popup').css({display: 'flex'});
	});

	$('.js-slider').slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		prevArrow: '.js-btn-left',
		nextArrow: '.js-btn-right',
		responsive: [
			{
				breakpoint: 1170,
				settings: {
					slidesToShow: 4,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 999,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 756,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 511,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	});
});



// WEBPACK FOOTER //
// ./app/scripts/app.js